module.exports = __webpack_public_path__ + "img/edge_patrimoine_industrie.63fd3691.svg";